import queryString from "query-string"

// Valeurs communes aux formulaires des landing pages ISG (reprises des anciens WebToLead)
// LastForm__c propre à chaque LP : valeurs à définir
export const LAST_FORMS = {
  rentreeDecalee: 'LP Demande de Doc',
  admissionParallele: 'LP Demande de Doc',
  master: 'LP Demande de Doc',
  postBac: 'LP Demande de Doc',
  postBacParcoursup: 'LP Demande de Doc',
  programmesPostBac: 'LP Demande de Doc',
  programmesPostBacParcoursup: 'LP Demande de Doc',
  parcoursupPhaseComplementaire: 'LP Demande de Doc'
}

const toOptions = values => values.map(value => ({ label: value, value }))

export const academicLevelsRentreeDecalee = toOptions(['Troisième', 'Seconde', 'Première', 'Terminale (BAC)', 'BAC', 'Bac +1', 'Bac +2', 'Bac +3', 'Bac +4', 'Bac +5', 'Salarié', 'Autre', 'International'])
export const academicLevelsAdmissionParallele = toOptions(['Bac +2', 'Bac +3', 'Bac +4'])
export const academicLevelsMaster = toOptions(['Bac +3', 'Bac +4', 'Bac +5'])
export const academicLevelsPostBac = toOptions(['Seconde', 'Première', 'Terminale (BAC)', 'BAC', 'Bac +1', 'Bac +2', 'Bac +3', 'Bac +4', 'Bac +5'])

export const campusSansNice = toOptions(['Paris', 'Bordeaux', 'Lille', 'Lyon', 'Nantes', 'Strasbourg', 'Toulouse'])
export const campusAvecNice = toOptions(['Paris', 'Bordeaux', 'Lille', 'Lyon', 'Nantes', 'Nice', 'Strasbourg', 'Toulouse'])

export const PHONE_CALL = 'telephone'
export const CAMPUS_MEETING = 'campus'

// Identifiants publicitaires présents dans l'URL (GCLID__c / FBCLID__c), envoyés uniquement s'ils sont renseignés
export const getAdClickIds = () => {
  const { gclid, fbclid } = queryString.parse(document.location.search)
  const ids = {}
  if (gclid) ids.GCLID__c = gclid
  if (fbclid) ids.FBCLID__c = fbclid
  return ids
}

// Tâche créée selon le type de rendez-vous choisi (remplace l'ancien champ Commentary__c)
export const getRendezVousTask = (rendezVous, campusLabel) => {
  if (rendezVous === CAMPUS_MEETING) {
    return {
      subject: 'Rendez-vous sur le campus',
      description: `Le prospect souhaite un rendez-vous sur le campus (${campusLabel}).`
    }
  }
  return {
    subject: 'Recontacter le prospect',
    description: 'Le prospect souhaite un rendez-vous téléphonique.'
  }
}

// Validation "au moins un programme coché" sur un ensemble de cases
export const atLeastOneProgram = (fields, errorPath) => function (lead) {
  if (fields.some(field => Boolean(lead?.[field]))) return true

  return this.createError({
    path: errorPath,
    message: "Veuillez sélectionner au moins un programme d'intérêt."
  })
}
